import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { API_URL } from "../constants";
import { BaseDataService, DataService } from "../core/services";

@Injectable()
export class QrCodeService extends BaseDataService {
    constructor(protected dataService: DataService, private http: HttpClient) {
        super(dataService, API_URL);
    }
    public decode(data: any) {
        let url = `${API_URL}/Qr/Decode`;
        return this.http.post(url, data)
    }

}



// WEBPACK FOOTER //
// ./src/app/services/qrcode.service.ts